import toast from "react-hot-toast";

function isRtlDocument() {
  const dir = document?.documentElement?.getAttribute("dir");
  const lang = document?.documentElement?.getAttribute("lang");
  return dir === "rtl" || lang === "ar";
}

function normalizeMessage(message: unknown): string | null {
  if (typeof message === "string") {
    const m = message.trim();
    return m ? m : null;
  }
  if (message === null || message === undefined) return null;
  const m = String(message).trim();
  return m ? m : null;
}

export function toastSuccess(message: unknown) {
  const m = normalizeMessage(message);
  if (!m) return;
  toast.success(m, {
    style: { direction: isRtlDocument() ? "rtl" : "ltr" },
  });
}

export function toastError(message: unknown) {
  const m = normalizeMessage(message);
  if (!m) return;
  toast.error(m, {
    style: { direction: isRtlDocument() ? "rtl" : "ltr" },
  });
}

export function toastInfo(message: unknown) {
  const m = normalizeMessage(message);
  if (!m) return;
  toast(m, {
    style: { direction: isRtlDocument() ? "rtl" : "ltr" },
  });
}

